import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import "./../bindings/bao-number-box";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
class ShiftPlanMinRequired extends BaseViewModel {
    Name: KnockoutObservable<string> = ko.observable("");
    ShiftbookIds: KnockoutObservableArray<string>;
    AllShiftTypes: KnockoutObservable<boolean> = ko.observable(false);
    AllWorkplaceTypes: KnockoutObservable<boolean> = ko.observable(false);
    MinRequired: KnockoutObservable<number> = ko.observable(0);
    ShiftTypeBaoSearcherEnabled: KnockoutObservable<boolean> = ko.observable(true);
    WorkplaceBaoSearcherEnabled: KnockoutObservable<boolean> = ko.observable(true);
    //ShiftbookIds = ko.observableArray([]);
    //ShiftbookIds2: any = ko.observableArray([]);
    ShiftbookItems = ko.observable([]);
    //ShiftbookSearchBinding: Bindings.baoSearcher = {
    //};
    ShiftTypeName: KnockoutObservable<string> = ko.observable("");
    ShiftTypeId: KnockoutObservable<string> = ko.observable("");
    ShiftTypeSearchBinding: Bindings.baoSearcher = {
        ObjectId: this.ShiftTypeId,
        ObjectValue: 'Name',
        SearchType: 'ShiftType',
        AutoComplete: true,
        AutoCompleteOpts: {
            preselect: false
        },
        AutoSearch: true,
        Enabled: this.ShiftTypeBaoSearcherEnabled
    };
    WorkplaceName: KnockoutObservable<string> = ko.observable("");
    WorkplaceId: KnockoutObservable<string> = ko.observable("");
    WorkplaceSearchBinding: Bindings.baoSearcher = {
        ObjectId: this.WorkplaceId,
        ObjectValue: 'Name',
        SearchType: 'Workplace',
        AutoComplete: true,
        AutoCompleteOpts: {
            preselect: false
        },
        AutoSearch: true,
        Enabled: this.WorkplaceBaoSearcherEnabled
    };
    Sort: KnockoutObservable<number> = ko.observable();
    FromDateJs = ko.observable();
    ToDateJs = ko.observable();
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.AllShiftTypes.subscribe(() => {
            this.SetShiftTypeEnabled();
        });
        this.AllWorkplaceTypes.subscribe(() => {
            this.SetWorkplaceEnabled();
        });
        //this.ShiftbookItems.subscribe(() => {
        //    this.Shiftbook(this.ShiftbookItems());
        //})
    }
    // overwrite BAO's MinimizeEntity method so the BaseViewModel sends the ShiftbookIds to the server. (It's an object that wouldn't be sent else)
    MinimizeEntity() {
        //TODO An der Stelle arbeite ich gerade
        var model = ko.map.toJS(this, true);
        for (var o in model) {
            if ((typeof model[o] === "object" && !(Object.prototype.toString.call(model[o]) === '[object Array]')) || typeof model[o] === "function") {
                delete model[o];
            }
        }
        return model;
    }
    SetShiftTypeEnabled() {
        if (this.AllShiftTypes()) {
            this.ShiftTypeName("");
            this.ShiftTypeId(null);
        }
        this.ShiftTypeBaoSearcherEnabled(!this.AllShiftTypes());
    }
    SetWorkplaceEnabled() {
        if (this.AllWorkplaceTypes()) {
            this.WorkplaceName("");
            this.WorkplaceId(null);
        }
        this.WorkplaceBaoSearcherEnabled(!this.AllWorkplaceTypes());
    }
    CompleteCheck() {
        if (this.FromDateJs() && this.ToDateJs() && Number(this.FromDateJs()) > Number(this.ToDateJs())) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage('msgValidateStartEnd'), "info");
            return false;
        }

        var isComplete: boolean = true;
        if (this.ShiftTypeId() == null && !this.AllShiftTypes()) {
            isComplete = false;
        }
        if (this.WorkplaceId() == null && !this.AllWorkplaceTypes()) {
            isComplete = false;
        }
        if (this.ShiftbookIds() == null || this.ShiftbookIds().length == 0) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "ShiftPlanMinRequired/Init";
    }
    loaded() {
        super.loaded();
        if (!this.IsNew() && (this.ShiftTypeName() == "" || this.ShiftTypeName() == null)) {
            this.AllShiftTypes(true);
        }
        if (!this.IsNew() && (this.WorkplaceName() == "" || this.WorkplaceName() == null)) {
            this.AllWorkplaceTypes(true);
        }
        //this.ShiftbookItems(this.Shiftbook());
        this.TabPage.DirtyFlag(false);
    }
}
export default ShiftPlanMinRequired;